import React from "react";

function SelectCyrcleIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="9" cy="9" r="8.25" stroke="#D0D5DD" strokeWidth="1.5" />
    </svg>
  );
}

export default SelectCyrcleIcon;
